module.exports = __webpack_public_path__ + "img/sld_scb_6_t1_red.35c1b814.svg";